<template>
  <div id="top">
     <v-img :src="'/img/sepia.jpg'" width="100%" class="grey lighten-2"></v-img>
  </div>
</template>

<script>
    export default {
      name: 'Top',
        data: () => ({

          })
      }
</script>

<style>
  #top {
    margin-top: 50px;
    background-color: #b4b6b0!important;
  }
  #top h1 {
    font-size: 22px;
    font-family: WalkwayBoldRegular;
    color: #342b19;
  }
  .fade-enter { 
    opacity: 0; 
  }
  .fade-enter-active { 
    transition: 1s; 
  }
  .fade-leave-active { 
    transition: 1s; opacity: 0; 
  }
  .slider {
    position: relative;
    margin: auto!important;
    border-right: 5px solid #b4b6b0!important;
  }
  .slider-title {
    font-family:  'Open Sans Condensed', sans-serif!important;
  }
  .slide-footer {
    position: absolute;
    opacity: 0.6;
    font-family: 'Open Sans Condensed', sans-serif;
    background-color: rgb(53, 48, 48);
    width: 100%;
    padding: 5px 10px;
    bottom: 0;
    left: 0;
    color: #fff;
    font-size: 14px;
  }
  .slide-footer span {
    font-size: 20px; 
    font-weight: bold;
  }
  #top .slider-logn-text {
    font-size: 16px;
    font-family: Aial, Helvetica, sans-serif;
  }
@media (max-width: 1260px) {
  #top .slider-logn-text {
    font-size: 14px !important;
  }
}
@media (max-width: 768px) {
  #top .slider-logn-text {
    font-size: 12px !important;
  }
}
@media (max-width: 600px) {
  .slider {
    border: none!important;
  }
}
</style>